<script lang="ts" setup>
import type { Components } from '@ionic/core'
import type { AssociationMembershipResponse } from '~~/openapi-client/gen/schemas'

defineProps<{
	members: AssociationMembershipResponse[]
	nav: ComponentPublicInstance<Components.IonNav>
}>()
</script>

<template>
	<ModalContent title="Mitglieder eingeladen">
		<section class="ion-padding">
			<ion-img
				src="/assets/250701_vci_illustration_mitglied_eingeladen.svg"
				alt="Mitglieder einladen Illustration"
			/>
			<div class="success-message">
				<ion-text>
					<h3>Sie haben {{ members.length === 1 ? 'ein' : members.length }} Mitglied{{ members.length === 1 ? '' : 'er' }} <br> eingeladen.</h3>
				</ion-text>
			</div>
		</section>
	</ModalContent>
</template>

<style scoped lang="scss">
.success-message {
	margin-top: 120px;
	text-align: center;

	h3 {
		font-weight: 600;
	}
}
</style>
